import { DocumentType } from "generated-graphql/graphql";

/**
 * The attach-time PDF loadability check applies only to invoice PDFs — invoices
 * are the only document type mailed via Lob, so a malformed one must be caught
 * before it silently fails the payment. Receipts are never mailed, and other
 * types don't go through this gate, so they are left alone.
 */
export function shouldValidatePdf(
  documentType?: DocumentType | null,
  fileExtension?: string | null
): boolean {
  const normalizedExtension = (fileExtension ?? "").trim().replace(/^\./, "").toLowerCase();
  return documentType === DocumentType.Invoice && normalizedExtension === "pdf";
}
